<template>
	<div class="reporthead FlexBetween" :style="customStyle" :class="{'borderd': isborder}">
		<!--  -->
		<div class="head_left FlexRow">
			<template v-if="iscustom">
				<slot name="custom"></slot>
			</template>
			<template v-else>
				<div class="returnpage FlexRow" @click="returnpage">
					<i class="el-icon-back"></i>
					<span>
						返回
					</span>
				</div>
				<div class="curr_tit">
					{{title}}
				</div>
			</template>
		</div>
		<!--  -->
		<!--  -->
		<div class="head_right FlexRow" v-if="rightshow">
			<el-select class="input_w174 style1" v-model="sort_type" @change="fn_Resets">
				<el-option v-for="(item, index) in sort_list" :label="item.name" :value="index + 1"></el-option>
			</el-select>

			<el-input clearable class="righ_name" placeholder="搜索" style="margin-right: 5px;width: 329px;"
				v-model="search_name" @keyup.enter.native="fn_Resets" v-if="types != 3">
				<el-select style="width: 100px;color: #606266;" v-model="search_type" slot="prepend" placeholder="请选择">
					<el-option label="内容名称" :value="1"></el-option>
				</el-select>
				<el-button slot="append" icon="el-icon-search" @click="fn_Resets"></el-button>
			</el-input>

			<el-button class="export" @click="fn_exportbtn" v-if="export_show">导出</el-button>
		</div>
		<!--  -->
	</div>
</template>

<script>
	import {
		exportExcel,
	} from "../js/report.js"
	export default {
		props: {
			types: {
				type: Number,
				default: 1,
			},
			
			exportid: {
				type: String,
				default: '',
			},
			exportname: {
				type: String,
				default: '',
			},
			title: {
				type: String,
				default: '',
			},
			rightshow: {
				type: Boolean,
				default: true,
			},
			isborder: {
				type: Boolean,
				default: true,
			},
			iscustom: {
				type: Boolean,
				default: false,
			},
			export_show: {
				type: Boolean,
				default: true,
			},
			
			customStyle: {
				type: String,
				default: '',
			},
			
			sort_list: {
				type: Array,
				default: ()=>{
					return []
				},
			},
			
			
			
		},
		watch: {
			search_name(){
				if(this.search_name == '') {
					this.fn_Resets()
				}
			},
		},
		methods: {
			fn_Resets() {
				let res = {
					sort_type: this.sort_type,
					search_name: (this.search_name + '').trim(),
				}
				this.$emit('retusults', res)
			},
			// 导出表格
			fn_exportbtn() {
				exportExcel(`#${this.exportid || 'exportTab'}`, this.exportname)
			},
			returnpage() {
				this.$router.go(-1)
			},
		},
		data() {
			return {
				sort_type: 1,
				search_name: '',
				search_type: 1,
			}
		},
	}
</script>

<style lang="scss" scoped>
	.reporthead.borderd{
		border-bottom: solid 1px rgba(235, 238, 245, 1);
	}
	.reporthead {
		width: 100%;
		padding: 0 18px 0 25px;
		height: 58px;
		background-color: #fff;
		

		.head_left {
			height: 100%;
			.returnpage {
				height: 16px;
				border-right: solid 1px rgba(232, 232, 232, 1);
				margin-right: 20px;
				padding-right: 18px;
				cursor: pointer;

				i {
					margin-right: 10px;
					color: rgba(56, 56, 56, 1);
				}

				span {
					font-size: 16px;
					font-weight: 400;
					letter-spacing: 0px;
					line-height: 0px;
					color: rgba(56, 56, 56, 1);
					text-align: left;
				}
			}

			.curr_tit {
				font-size: 16px;
				font-weight: 400;
				letter-spacing: 0px;
				line-height: 0px;
				color: rgba(56, 56, 56, 1);
				text-align: left;
			}
		}
	}

	.head_right {
		.input_w174 {
			width: 177px;
			margin-right: 5px;
		}

		.style1 {

			/deep/ .el-input {
				input {
					background-color: rgba(250, 250, 250, 1);
				}
			}
		}

		.righ_name {

			/deep/ .el-input-group__prepend {
				background-color: rgba(250, 250, 250, 1);
				width: 68px !important;
			}
		}

		.el-button {
			height: 32px;
			padding: 10px 15px;
			background: var(--themeColors);
			color: #fff;
			border: none;
		}

		/deep/ .el-input-group__append {
			padding: 0 !important;
			border: none;
			background-color: rgba(250, 250, 250, 1);

			.el-button {
				padding: 0 !important;
				width: 32px;
				height: 32px !important;
				margin: 0 !important;
				background-color: #fff;
				color: #000;
				border: solid 1px rgba(220, 223, 230, 1);
				border-left: none;
			}
		}
	}
</style>
